import React, { useMemo, useState } from "react"
import CardInfoRealtime from "./component/realtime"
import CardInfoToday from "./component/today"
import ListRealTime from "./list"
import { isLoading } from "../component/loading/store"
import { useSelector } from 'react-redux'
import { Box, LinearProgress, Skeleton, Typography, Tabs, Tab, Grid, Stack } from "@mui/material"
import { criarFiltroMarca } from "../../utils/marca"

function AutoUpdateRealTimeProgress() {
    const counting = useSelector(state => state.progress.counting)
    const progress = useSelector(state => state.progress.progressValue)
    const secondsRemaining = Math.max(0, Math.round(60 - (progress / 100 * 60)))

    if (!progress && !counting) {
        return null
    }

    return (
        <Stack spacing={0.5} sx={{ pb: 2, mx: 0.5 }}>
            <Typography variant="h6" textAlign="left" sx={{ display: 'block' }}>
                Atualizando em... 00:{secondsRemaining.toString().padStart(2, '0')}
            </Typography>
            <LinearProgress
                value={progress}
                sx={{ height: 8, borderRadius: 5, }}
                variant="determinate"
            />
        </Stack>
    )
}

export default function RealTime() {
    const [tab, setTab] = useState(0)
    const kpiRealTime = useSelector((state) => state.kpiRealTime)
    const selectedTrademarks = useSelector((state) => state.trademark.selecteds)
    const loading = useSelector((state) => isLoading(state, 'KPI_REALTIME'))

    const salesAtivas = useMemo(() => {
        if (!kpiRealTime.listAllSalesToday || !kpiRealTime.listAllSalesToday.length) {
            return []
        }

        if (!selectedTrademarks.length) {
            return kpiRealTime.listAllSalesToday.filter(item => item.ativo)
        }

        const filtroMarca = criarFiltroMarca(selectedTrademarks)

        return kpiRealTime.listAllSalesToday.filter(item => item.ativo && filtroMarca(item))
    }, [kpiRealTime, selectedTrademarks])

    return (
        <>
            <AutoUpdateRealTimeProgress />

            <Tabs
                value={tab}
                onChange={(_, newValue) => setTab(newValue)}
                sx={{ borderBottom: 1, borderColor: "divider", mx: 0.5 }}
            >
                <Tab label="Visão geral" />
                <Tab label="Listagem" />
            </Tabs>

            <Box mt={3}>
                {tab === 0 && (
                    <>
                        {!loading ? (
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <CardInfoRealtime />
                                </Grid>

                                <Grid item xs={12}>
                                    <CardInfoToday />
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Skeleton variant="rounded" height={150} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant="rounded" height={150} />
                                </Grid>
                            </Grid>
                        )}
                    </>
                )}

                {tab === 1 && (
                    <ListRealTime data={salesAtivas} />
                )}
            </Box>
        </>
    )
}